import React from "react";
import "./app.css";
import { getImage } from "../../../../../../utils/getImages";
const ThumbnailPreview = ({ cardData, activetab }) => {
  return (
    <div>
      <div className="destination-package" style={{ width: "300px",margin:"20px" }}>
        <img
          alt=""
          src=
          {activetab === "english"
            ? getImage(cardData?.image)
            : activetab === "simplified_chinese"
              ? getImage(cardData?.simplified_chinese_image)
              : activetab === "arabic"
                ? getImage(cardData?.arabic_image)
                : activetab === "bahasa"
                  ? getImage(cardData?.bahasa_image)
                  :getImage(cardData?.traditional_chinese_image)}

          className="w-100 rounded"
        />

          <div>
            <div className="info" style={{bottom:"40px"}}>
              <p className="place" style={{fontSize:"15px!important"}} >
              {activetab === "english"
                  ? cardData?.title
                  : activetab === "simplified_chinese"
                  ? cardData?.simplified_chinese_title
                  : activetab === "arabic"
                  ? cardData?.arabic_title
                  : activetab === "bahasa"
                  ? cardData?.bahasa_title
                  : cardData?.traditional_chinese_title}
              </p>
            </div>

          </div>
     
      </div>
    </div>
  );
};

export default ThumbnailPreview;
